<template>
  <div >
    <job-header-simple header_title="注册结果"></job-header-simple>
    <div class="view-page">
      <img src="./assets/icon_success.png">
      <p class="text-p1">注册提交成功</p>
      <p class="text-p2">注册将在1~3个工作日内完成审核，注册结果将以短信形式通知，请注意查收</p>
      <van-button color="#7a84fb" size="small" @click="goHome">返回首页</van-button>
      <van-button color="#7a84fb" size="small" @click="goAddBank">添加银行卡</van-button>
    </div>
  </div>
</template>

<script>
import {
  button
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";

export default {
  components: {
    [button.name]: button,
    jobHeaderSimple
  },
  methods: {
    goHome() {
      this.$router.push({
          path: "/individual_index"
      });
    },
    goAddBank() {
      this.$router.push({
        path: "/card",
      });
    }
  },
};
</script>

<style lang="less" scoped>
.view-page{
  text-align: center;
  background: #ffffff;
  margin: 20px 10px;
  padding: 30px 0;
  border-radius: 10px;
  img {
    width: 40px;
    height: 40px;
  }
  .text-p1 {
    font-size: 16px;
  }
  .text-p2 {
    padding-top: 10px;
    font-size: 14px;
    margin: 0 40px;
    line-height: 24px;
    padding-bottom: 4px;
    color: #666;
  }
  .van-button{
    margin: 0 10px;
    width: 130px;
  }
}

</style>


